import { render, staticRenderFns } from "./editPurchasesReturn.vue?vue&type=template&id=5d2a9ea6&scoped=true&"
import script from "./editPurchasesReturn.vue?vue&type=script&lang=js&"
export * from "./editPurchasesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a9ea6",
  null
  
)

export default component.exports